module.exports = __webpack_public_path__ + "static/media/kayden-kross-icon.e4b28642.jpg";